import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 *
 * On every route change:
 *   • If the URL contains a hash (e.g. `/#ask-istatec-ai`), smooth-scroll to
 *     that element once it's in the DOM. We retry across a couple of animation
 *     frames because the target section might mount slightly after the route
 *     transition (framer-motion, code-splitting, etc.).
 *   • Otherwise, reset the scroll to the top of the page.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace(/^#/, '');
      // Try a few times — the target may not exist yet during the first paint.
      let attempts = 0;
      const scrollToTarget = () => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (attempts++ < 10) {
          requestAnimationFrame(scrollToTarget);
        }
      };
      requestAnimationFrame(scrollToTarget);
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};
